export const questionsCategoryF: Record<string, PolicyFormQuestion> = {
  medicalNarcoticsUseFirstInsured: {
    id: 'medical-narcotics-use-first-insured',
    questionRef: 'medicalNarcoticsUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used narcotics, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalBarbituratesUseFirstInsured: {
    id: 'medical-barbiturates-use-first-insured',
    questionRef: 'medicalBarbituratesUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used barbiturates, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAmphetaminesUseFirstInsured: {
    id: 'medical-amphetamines-use-first-insured',
    questionRef: 'medicalAmphetaminesUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used amphetamines, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHallucinogensUseFirstInsured: {
    id: 'medical-hallucinogens-use-first-insured',
    questionRef: 'medicalHallucinogensUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used hallucinogens, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHeroinUseFirstInsured: {
    id: 'medical-heroin-use-first-insured',
    questionRef: 'medicalHeroinUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used heroin, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCocaineUseFirstInsured: {
    id: 'medical-cocaine-use-first-insured',
    questionRef: 'medicalCocaineUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used cocaine, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMarijuanaUseFirstInsured: {
    id: 'medical-marijuana-use-first-insured',
    questionRef: 'medicalMarijuanaUseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured used marijuana, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAlcoholTreatmentFirstInsured: {
    id: 'medical-alcohol-treatment-first-insured',
    questionRef: 'medicalAlcoholTreatmentFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured received medical treatment to discontinue the use of alcohol?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPrescribedMedicationTreatmentFirstInsured: {
    id: 'medical-prescribed-medication-treatment-first-insured',
    questionRef: 'medicalPrescribedMedicationTreatmentFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured received medical treatment to discontinue the use of prescribed medication?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNonPrescribedDrugsTreatmentFirstInsured: {
    id: 'medical-non-prescribed-drugs-treatment-first-insured',
    questionRef: 'medicalNonPrescribedDrugsTreatmentFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured received medical treatment to discontinue the use of non-prescribed drugs?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNarcoticsUseSecondInsured: {
    id: 'medical-narcotics-use-second-insured',
    questionRef: 'medicalNarcoticsUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used narcotics, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalBarbituratesUseSecondInsured: {
    id: 'medical-barbiturates-use-second-insured',
    questionRef: 'medicalBarbituratesUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used barbiturates, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAmphetaminesUseSecondInsured: {
    id: 'medical-amphetamines-use-second-insured',
    questionRef: 'medicalAmphetaminesUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used amphetamines, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHallucinogensUseSecondInsured: {
    id: 'medical-hallucinogens-use-second-insured',
    questionRef: 'medicalHallucinogensUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used hallucinogens, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHeroinUseSecondInsured: {
    id: 'medical-heroin-use-second-insured',
    questionRef: 'medicalHeroinUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used heroin, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCocaineUseSecondInsured: {
    id: 'medical-cocaine-use-second-insured',
    questionRef: 'medicalCocaineUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used cocaine, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMarijuanaUseSecondInsured: {
    id: 'medical-marijuana-use-second-insured',
    questionRef: 'medicalMarijuanaUseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured used marijuana, except as prescribed by a physician?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAlcoholTreatmentSecondInsured: {
    id: 'medical-alcohol-treatment-second-insured',
    questionRef: 'medicalAlcoholTreatmentSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured received medical treatment to discontinue the use of alcohol?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPrescribedMedicationTreatmentSecondInsured: {
    id: 'medical-prescribed-medication-treatment-second-insured',
    questionRef: 'medicalPrescribedMedicationTreatmentSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured received medical treatment to discontinue the use of prescribed medication?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNonPrescribedDrugsTreatmentSecondInsured: {
    id: 'medical-non-prescribed-drugs-treatment-second-insured',
    questionRef: 'medicalNonPrescribedDrugsTreatmentSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured received medical treatment to discontinue the use of non-prescribed drugs?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
};
